import React from 'react';
import { Grid } from '@material-ui/core';
import { Trans } from 'react-i18next';

import FormAlongsideText from './FormAlongsideText';
import FormSwitch from './FormSwitch';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import Tooltip from '../../components/UI/Tooltip/Tooltip';
import { ReactComponent as InfoIcon } from '../../assets/images/icon-info.svg';

interface IFormSwitchWithText extends ICommonFormProps {
    tooltip?: string;
}

/**Switch component with helper text alongside */
const FormSwitchWithText = (props: IFormSwitchWithText) => {
    const title = <Trans i18nKey={props.formProps?.tooltip} components={props.formProps?.tooltipComponents} />;

    return (
        <Grid container justify="center" alignItems="center" spacing={0} className={props.className}>
            <Grid item xs={props.label ? 3 : 12}>
                <FormSwitch {...props} />
            </Grid>

            {props.label && (
                <Grid item xs={9} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <FormAlongsideText label={props.label} secondLabel={props.formProps?.secondLabel} />

                    {props.formProps?.tooltip && (
                        <Tooltip title={title}>
                            <InfoIcon />
                        </Tooltip>
                    )}
                </Grid>
            )}
        </Grid>
    );
};

export default FormSwitchWithText;
